import { useCallback, useEffect, useState } from "react";
import { getStoredSelectedAccountId } from "../Constants/accountTypes";
import { fetchIbAccountCurrencies } from "../Services/ibAccountCurrenciesApi";

/**
 * Live multi-currency banking rails for Conta internacional (active IB account).
 * Refreshes when `accountKey` changes (HomeAccountSelector).
 */
export const useContaInternacionalCurrencies = ({ accountKey } = {}) => {
  const resolvedAccountKey =
    accountKey !== undefined ? accountKey : getStoredSelectedAccountId();

  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await fetchIbAccountCurrencies();
      setCurrencies(next);
    } catch (err) {
      setCurrencies([]);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload, resolvedAccountKey]);

  return { currencies, loading, error, reload };
};
